import React from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'

import { deleteKB, syncKB } from 'Actions/kb'

import hfIcon from 'Assets/images/happyfox.svg?url'
import zendeskIcon from 'Assets/images/zendesk.png'
import fileIcon from 'Assets/images/file.svg?url'
import settingsIcon from 'Assets/images/settings.svg?url'
import trashIcon from 'Assets/images/trash.svg?url'

const KBTile = (props) => {
  const { id, name, source, noOfarticles, noOfignoredSections, type, syncStatus, lastSyncAt, status, showModal } = props

  const dispatch = useDispatch()

  const onSettingsClick = () => {
    showModal(true)
  }

  const onDeleteClick = () => {
    dispatch(deleteKB({ kbId: id }))
  }

  const onSync = () => {
    dispatch(syncKB({ kbId: id }))
  }

  if (status === 'loading') {
    return <div className='kb-tile loading' />
  }

  return (
    <div className='kb-tile'>
      <div className='kb-tile-head-container'>
        <div className='kb-tile-heading'>
          <div className='kb-tile-title'>{name}</div>
          <div className='kb-tile-subhead'>{source}</div>
        </div>
        {type === 'happyfox_helpdesk' && <img className='tile-icon' src={hfIcon} />}
        {type === 'zendesk_support' && <img className='tile-icon' src={zendeskIcon} />}
        {type === 'csv_file' && <img className='tile-icon' src={fileIcon} />}
      </div>

      <div className='tile-stats'>
        <div>{noOfarticles} Articles</div>
        <div>{noOfignoredSections} Ignored sections</div>
      </div>

      <div className='tile-footer'>
        {syncStatus === 'not_started' && (
          <React.Fragment>
            <button onClick={onSync} className='button-primary mr-3'>
              Sync
            </button>
            <img onClick={onSettingsClick} className='tile-icon pointer' src={settingsIcon} />
          </React.Fragment>
        )}

        {syncStatus === 'completed' && (
          <React.Fragment>
            <button onClick={onSync} className='button-primary mr-3'>
              Sync
            </button>
            <span>Last synced {moment.utc(lastSyncAt).local().fromNow()}</span>
            <img onClick={onSettingsClick} className='tile-icon pointer' src={settingsIcon} />
          </React.Fragment>
        )}

        {(syncStatus === 'in_progress' || syncStatus === 'retraining' || !syncStatus) && (
          <React.Fragment>
            <button className='button-secondary mr-3'>Sync in progress</button>
          </React.Fragment>
        )}

        {syncStatus === 'validation_failed' && (
          <React.Fragment>
            <span className='text-danger'>Validation failed. Please delete and try again.</span>
            <img onClick={onDeleteClick} className='ml-auto pointer' src={trashIcon} />
          </React.Fragment>
        )}

        {syncStatus === 'failed' && (
          <React.Fragment>
            <button onClick={onSync} className='button-primary mr-3'>
              Sync
            </button>
            <span className='text-danger'>Sync failed. Please try again.</span>
            <img onClick={onSettingsClick} className='tile-icon pointer' src={settingsIcon} />
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default KBTile
